import moment from 'moment';
import { Scalars } from '../../../../generated/graphql';

type Date = Scalars['DateTime'];

export const fromNow = (date: Date, nowPassed: Date = moment()) => {
  const now = nowPassed || moment();
  const diffInDays = moment(now).diff(date, 'days');
  if (diffInDays > 5) {
    if (moment(date).year() === now.year()) {
      return moment(date).format('MMMM DD');
    }
    return moment(date).format('MMMM DD, YYYY');
  }
  return date ? moment(date).fromNow() : '1m';
};
